import { render, staticRenderFns } from "./ServiceComponentModelList.vue?vue&type=template&id=9e36f36c&scoped=true&"
import script from "./ServiceComponentModelList.vue?vue&type=script&lang=js&"
export * from "./ServiceComponentModelList.vue?vue&type=script&lang=js&"
import style0 from "./ServiceComponentModelList.vue?vue&type=style&index=0&id=9e36f36c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e36f36c",
  null
  
)

export default component.exports